import { RegisterBaseModel, REGISTER_BASE_EXCLUDE_PROPERTIES } from '@rift/models/restapi/RegisterBase.Model';
import { IRestModel } from '@shared/interface/IRestModel';
import { RestModelUtility } from '@shared/utility/RestModel.Utility';
import { IRegisterBaseModel } from '@rift/models/restapi/IRegisterBase.Model';

export interface IRegisterStaffAttendModel extends IRegisterBaseModel {
    untaggedPolygon: number;
    taggedPolygon: number;
}

export class RegisterStaffAttendModel extends RegisterBaseModel implements IRegisterStaffAttendModel, IRestModel {
    public untaggedPolygon: number = null;
    public taggedPolygon: number = null;

    public constructor() {
        super();

        this.registerProperty('untaggedPolygon');
        this.registerProperty('taggedPolygon');
    }

    public loadFromRestApiModel(restModel: any): void {
        RestModelUtility.loadProperties(restModel, this, 'RIFT-RegisterStaffAttendModel', ['registerType', ...REGISTER_BASE_EXCLUDE_PROPERTIES]);
        super.loadFromRestApiModel(restModel);

        this.setPropertyOriginalValue('untaggedPolygon', this.untaggedPolygon);
        this.setPropertyOriginalValue('taggedPolygon', this.taggedPolygon);

        this.setIndexes();
    }

    public toRestApiModel(): any {
        return {
            ...super.toRestApiModel(),
        };
    }

    public setIndexes(): void {
        super.setIndexesBase([], [], [this.untaggedPolygon, this.taggedPolygon]);
    }
}
